var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "el-tabs",
          {
            attrs: { type: "border-card" },
            model: {
              value: _vm.currentTab,
              callback: function ($$v) {
                _vm.currentTab = $$v
              },
              expression: "currentTab",
            },
          },
          [
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("ssrManage.baseInfoPane"),
                  name: "baseInfoPane",
                },
              },
              [
                _c(
                  "div",
                  { staticStyle: { "padding-bottom": "15px" } },
                  [
                    _vm.ssr.canAccept
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.accept(true)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("ssrManage.biding")))]
                        )
                      : _vm._e(),
                    _vm.ssr.canAccept
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.accept(false)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("ssrManage.refuse")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c("ssr-manage-add", {
                  model: {
                    value: _vm.ssr,
                    callback: function ($$v) {
                      _vm.ssr = $$v
                    },
                    expression: "ssr",
                  },
                }),
              ],
              1
            ),
            _vm._l(_vm.ssr.ssrRounds, function (round) {
              return round.ssrRoundSuppliers[0].status != null
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        name: "round" + round.roundNumber,
                        label: `Proposal ${_vm.toRomanNum(round.roundNumber)}`,
                      },
                    },
                    [
                      _c("proposal-pane", {
                        attrs: {
                          showCopyToNewRound: _vm.showCopyToNewRound(round),
                          round: round,
                          ssr: _vm.ssr,
                        },
                        on: {
                          copyToNewRound: function ($event) {
                            return _vm.copyToNewRound(round)
                          },
                          "update:round": function ($event) {
                            round = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: _vm.$t("ssrManage.spmCorePane"),
                  name: "spmCorePane",
                },
              },
              [
                _c("spm-core-pane", {
                  attrs: {
                    "can-edit": false,
                    rounds: _vm.ssr.ssrRounds,
                    ssr: _vm.ssr,
                  },
                }),
              ],
              1
            ),
            _vm.isRecommendation
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: { label: "Recommendation", name: "Recommendation" },
                  },
                  [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/img/u15566.png"),
                          alt: "",
                        },
                      }),
                      _c("div", [_vm._v("Congratulations，you did it！")]),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }